import ChatLock from '@assets/images/common/icon/channel/lock.svg';
import OpenSidebarIcon from '@assets/images/common/icon/channel/open_sidebar.svg';
import ProhibitedIcon from '@assets/images/common/icon/channel/prohibited.png';
import { Channel } from '@src/api/shared/community/channelApiClient';
import Button from '@src/ui/elements/button/Button';
import { Emoji } from 'emoji-picker-react';
import React from 'react';

import { NAVIGATION_TARGET, NavigationTarget } from '../constants/navigationTarget';

interface Props {
  channel: Channel;
  toggleMobileSidebar: () => void;
  navigate: (to: NavigationTarget) => void;
}

const ChannelAccessDeniedNotLoggedIn: React.FC<Props> = ({
  channel,
  toggleMobileSidebar,
  navigate,
}) => (
  <main className='h-full'>
    <div className='hidden items-center justify-between lg:flex'>
      <div className='flex h-[60px] w-full items-center'>
        <button
          className='hidden size-[32px] flex-[0_0_auto] place-items-center lg:grid'
          onClick={toggleMobileSidebar}
          data-setting-menu=''
        >
          <img
            src={OpenSidebarIcon}
            alt=''
            width={16}
            height={16}
            className='size-[16px]'
          />
        </button>
        <div className='flex w-full items-center lg:w-[calc(100%-32px)]'>
          <div className='flex w-[calc(100%-60px)] items-center gap-2 lg:items-center'>
            <h1 className='flex max-w-[60%] items-center gap-2 truncate text-[18px] font-bold lg:max-w-full lg:text-[16px]'>
              <Emoji
                unified={channel?.emoji || ''}
                size={20}
                key={`emoji-header-${channel?.emoji}`}
              />
              <span className='truncate'>{channel?.name}</span>
            </h1>
            <img
              src={ChatLock}
              alt=''
              width={20}
              height={20}
              className='size-[20px] object-contain'
            />
          </div>
        </div>
      </div>
    </div>
    <div className='grid h-full place-items-center overflow-scroll bg-gray-10 xl:h-[calc(100vh-61px)] md:h-[calc(100vh-121px)]'>
      <div className='w-full px-6 md:max-w-[390px]'>
        <img
          className='mx-auto mb-8 md:mb-3'
          width={104}
          height={104}
          src={ProhibitedIcon}
          alt=''
        />
        <h1 className='mb-6 text-center text-xl font-semibold leading-loose md:text-lg'>
          このチャンネルはメンバー限定です
        </h1>
        <div>
          <p className='mb-[44px] text-center text-sm leading-loose md:mb-6'>
            新規会員登録、またはログインした上で管理者に
            <br className='hidden md:block' />
            チャンネルへの招待を依頼してください。
          </p>
          <div className='mx-auto flex flex-col justify-center'>
            <div className='mx-auto mb-6 w-[360px] md:mb-4 md:w-full'>
              <Button
                size='m'
                fullRounded
                fullWidth
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(NAVIGATION_TARGET.REGISTRATION);
                }}
              >
                新規会員登録
              </Button>
            </div>
            <p className='mb-3 h-[26px] text-center text-sm'>すでにアカウントをお持ちの方</p>
            <div className='mx-auto w-[360px] md:w-full'>
              <Button
                size='m'
                fullRounded
                fullWidth
                outline
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(NAVIGATION_TARGET.LOGIN);
                }}
              >
                ログイン
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
);

export default ChannelAccessDeniedNotLoggedIn;
